import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteEventService } from "../services/deleteEventService";

export function useDeleteEvent() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (keypointId) => deleteEventService(keypointId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["events-by-month"] });// Refetch events
      queryClient.invalidateQueries({ queryKey: ["retail-events-by-month"] });
      queryClient.invalidateQueries({ queryKey: ["wholesale-events-by-month"] });
      queryClient.invalidateQueries({ queryKey: ["ecom-events-by-month"] });
    },
  });
}